import { ChooseHoldingAndCompanyComponent } from "./../choose-holding-and-company/choose-holding-and-company.component";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { IHolding } from "./../../../interfaces/holding";
import { Component, OnInit } from "@angular/core";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { Router } from "@angular/router";
import { TranslateService } from "@ngstack/translate";
import { SoundEnum } from "src/app/enums/sound.enum";
import { HidService } from "src/app/services/common/hid.service";
import { MatDialog } from "@angular/material";
import { CIDService } from "src/app/services/common/cid.service";
import { BIDService } from "src/app/services/common/bid.service";
import { JwtHelperService } from "@auth0/angular-jwt";
import { AccountService } from "src/app/services/http/business/account/account.service";
import * as screenfull from "screenfull";
import { environment } from "src/environments/environment";
import { SubsidiaryContractService } from "src/app/services/http/business/subsidiary/dashboard/subsidiary-contract.service";
import { PaymentService } from "src/app/services/http/business/payment/payment.service";

@Component({
  selector: "app-selecting-holding",
  templateUrl: "./selecting-holding.component.html",
  styleUrls: ["./selecting-holding.component.css"]
})
export class SelectingHoldingComponent implements OnInit {

  holdingList: IHolding[];
  url = environment.BaaseUrl;
  userInfo: any;
  token = localStorage.getItem("token");
  showManagement = false;
  showAgh = false;
  wallet = 0;
  nationalCode: any;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private bidService: BIDService,
    private cidService: CIDService,
    private hidService: HidService,
    private snackBar: SnackBarService,
    private paymentService: PaymentService,
    public translate: TranslateService,
    private holdingService: HoldingService,
    private subsidiaryContractService: SubsidiaryContractService,
    private accountService: AccountService
  ) { }


  ngOnInit() {
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(this.token);
    this.nationalCode = decodedToken.un;
    this.userInfo = decodedToken.fname;

    // this.hidService.setHID("");
    this.cidService.setCID("");
    this.bidService.setBID("");
    this.getHoldingList();

    this.setAccess();
    this.getWallet();
  }


  getWallet() {
    this.paymentService.getWallet(this.nationalCode).subscribe(
      res => {
        this.wallet = res.CreditCompany;
      }
    );
  }

  getHoldingList() {
    this.holdingService.list().subscribe(res => {
      this.holdingList = res.DataList;
    });
  }

  fullScreenToggle(): void {
    if (screenfull.enabled) {
      screenfull.toggle();
    }
  }

  getStatus(e) {
    if (e.IsConfirmed == false) return "red";
    if (e.IsOwner && e.IsActive) return "green";
    if (e.IsOwner == true && e.IsActive == false) return "gray";
    if (e.IsConteract == true && e.IsActive == false) return "red";
    if (e.IsConteract == true && e.IsActive == true) return "green";
  }

  getStatusColor(e) {
    if (e.IsConfirmed == false) return "default";
    if (e.IsOwner && e.IsActive) return "primary";
    if (e.IsOwner == true && e.IsActive == false) return "accent";
    if (e.IsConteract == true && e.IsActive == false) return "default";
    if (e.IsConteract == true && e.IsActive == true) return "primary";
  }

  IsOwn(holding: any) {
    return holding.IsOwner
  }
  HasContract(holding: any) {
    if (!holding.IsOwner && holding.IsConteract)
      return true;
    else
      return false;
  }

  onClick(e) {
    if (e.IsOwner && e.IsConfirmed) {
      this.hidService.setHID(e.HoldingEncryptCode);
      this.router.navigate(["management"]);
    }
    if (e.IsOwner && e.IsConfirmed == false) {
      this.snackBar.OpenSnackBar(
        this.translate.get("wrong.holdingIsNotConfirmed"),
        "ok",
        5000,
        SoundEnum.beep
      );
    }
    if (!e.IsOwner && e.IsConfirmed) {
      this.hidService.setHID(e.HoldingEncryptCode);
      this.dialog.open(ChooseHoldingAndCompanyComponent, {
        width: "550px",
        data: e
      });
    }
  }
  setAccess() {
    this.holdingService.list().subscribe(res => {
      console.log(res);

      if (res && res.Total)
        this.showManagement = true;
      // this.holdingList = res.DataList;
    });
    this.subsidiaryContractService.getContract(null).subscribe(
      res => {
        if (res && res.Total)
          this.showAgh = true;
      }
    );
  }

  logout() {
    this.accountService.logout();
  }
}
